export default __webpack_public_path__ + "static/0020-c4173fe623228fb2b5fd474b6a7888bb.png";